<template>
  <footer class="relative mt-auto overflow-hidden" style="background: linear-gradient(160deg, #001a3a 0%, #002D62 60%, #001a3a 100%)">
    <!-- Diamond pattern overlay -->
    <div class="absolute inset-0 diamond-bg-light opacity-60 pointer-events-none" />
    <!-- Gold top accent line -->
    <div class="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-mlb-gold/60 to-transparent" />

    <div class="relative max-w-7xl mx-auto px-6 pt-10 pb-8">
      <div class="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">

        <!-- Brand column -->
        <div class="md:col-span-2">
          <div class="flex items-center gap-3 mb-3">
            <BrandLogo :size="30" class="text-white" />
            <div>
              <span class="block text-white font-black text-base tracking-wide leading-none" style="font-family: var(--font-display)">SOFTBALL STATS CLUB</span>
              <span class="block text-mlb-gold text-[10px] font-semibold tracking-[0.15em] mt-0.5" style="font-family: var(--font-display)">YOUR ANALYTICS HUB</span>
            </div>
          </div>
          <p class="text-blue-200/70 text-sm leading-relaxed max-w-xs">
            Track every at-bat, every inning, every season. Built by players, for players.
          </p>
          <!-- Stats strip -->
          <div class="flex gap-4 mt-4">
            <div class="text-center">
              <div class="text-mlb-gold font-black text-lg leading-none" style="font-family: var(--font-display)">100%</div>
              <div class="text-blue-300/60 text-[10px] font-semibold uppercase tracking-widest mt-0.5" style="font-family: var(--font-display)">Free</div>
            </div>
            <div class="w-px bg-white/10" />
            <div class="text-center">
              <div class="text-mlb-gold font-black text-lg leading-none" style="font-family: var(--font-display)">Live</div>
              <div class="text-blue-300/60 text-[10px] font-semibold uppercase tracking-widest mt-0.5" style="font-family: var(--font-display)">Stats</div>
            </div>
            <div class="w-px bg-white/10" />
            <div class="text-center">
              <div class="text-mlb-gold font-black text-lg leading-none" style="font-family: var(--font-display)">iOS</div>
              <div class="text-blue-300/60 text-[10px] font-semibold uppercase tracking-widest mt-0.5" style="font-family: var(--font-display)">App</div>
            </div>
          </div>
        </div>

        <!-- Quick links -->
        <div>
          <h4 class="font-bold text-white text-xs uppercase tracking-[0.12em] mb-4" style="font-family: var(--font-display)">Platform</h4>
          <ul class="space-y-2.5">
            <li>
              <router-link to="/dashboard" class="footer-link">
                <LayoutDashboard class="w-3.5 h-3.5" />
                Dashboard
              </router-link>
            </li>
            <li>
              <router-link to="/stats" class="footer-link">
                <BarChart2 class="w-3.5 h-3.5" />
                Player Stats
              </router-link>
            </li>
          </ul>
        </div>

        <!-- Legal -->
        <div>
          <h4 class="font-bold text-white text-xs uppercase tracking-[0.12em] mb-4" style="font-family: var(--font-display)">Legal</h4>
          <ul class="space-y-2.5">
            <li>
              <router-link to="/privacy-policy" class="footer-link">
                <Shield class="w-3.5 h-3.5" />
                Privacy Policy
              </router-link>
            </li>
            <li>
              <router-link to="/terms-of-service" class="footer-link">
                <FileText class="w-3.5 h-3.5" />
                Terms of Service
              </router-link>
            </li>
          </ul>
        </div>
      </div>

      <!-- Bottom bar -->
      <div class="pt-5 flex flex-col sm:flex-row justify-between items-center gap-2" style="border-top: 1px solid rgba(255,255,255,0.08)">
        <div class="text-blue-300/50 text-xs">
          &copy; {{ currentYear }} Softball Stats Club. All rights reserved.
        </div>
        <div class="flex items-center gap-1.5 text-blue-300/40 text-[11px]">
          <Zap class="w-3 h-3 text-mlb-gold/40" />
          Powered by Salient Data Solutions
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { LayoutDashboard, BarChart2, Shield, FileText, Zap } from 'lucide-vue-next'
import BrandLogo from '@/components/common/BrandLogo.vue'
const currentYear = new Date().getFullYear()
</script>

<style scoped>
.footer-link {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: rgba(191, 219, 254, 0.6);
  font-size: 0.875rem;
  transition: color 0.2s;
}

.footer-link:hover {
  color: #C89B3C;
}
</style>
